"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PanZoom", {
  enumerable: true,
  get: function get() {
    return _PanZoom["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _PanZoom["default"];
  }
});

var _PanZoom = _interopRequireDefault(require("./PanZoom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }